/*
 * Tã hub stage timeline — SCROLL-DRIVEN clone của Coterie "For every stage".
 * outer [data-stage-scroll] cao nhiều viewport, inner sticky ghim lại; tiến độ cuộn (0..1)
 * → p% điều khiển: track-fill (scaleX) + nhãn LỘ DẦN left→right (var --tabim-rv + clip-text)
 * + node tri-state past/active/future (ANCHOR tại giai đoạn, KHÔNG knob trượt) + thanh phủ
 * fill scaleX. Cập nhật bằng rAF-loop mỗi frame TRONG LÚC cuộn (mượt như Coterie, tránh
 * scroll-event bị gộp khi fling). Click nhãn = cuộn mượt tới giai đoạn. Zero deps; re-init an toàn.
 */
(function () {
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  function initSlider(slider) {
    if (slider.__tabimInit) return;
    slider.__tabimInit = true;

    var n = parseInt(slider.getAttribute('data-stages') || '4', 10);
    if (n < 2) return;
    var fill = slider.querySelector('[data-track-fill]');
    var track = slider.querySelector('[data-track]');
    var labels = Array.prototype.slice.call(slider.querySelectorAll('[data-stage-label]'));
    var nodes = Array.prototype.slice.call(slider.querySelectorAll('[data-node]'));
    var root = slider.closest('[data-stage-root]') || slider.parentElement;
    var scope = root || slider;
    var scroll = slider.closest('[data-stage-scroll]') || scope;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-card]'));
    var images = Array.prototype.slice.call(scope.querySelectorAll('[data-stage-img]'));

    // Mỗi "thanh phủ" sản phẩm = segment Gantt [start,end] trên track. Lớp accent bên trong
    // (data-bar-progress) wipe bằng transform:scaleX(localT) gốc trái; localT = tiến độ scroll
    // p map vào [start,end]. Vì segment đặt left=start%, rộng (end-start)% nên mép fill =
    // start% + (end-start)%·localT = p% của track → TRÙNG mép track-fill trên (1 đường tiến độ
    // dọc, như Coterie). Dùng transform (GPU compositor) thay width/bg → cuộn mượt 1:1.
    var barData = Array.prototype.slice.call(scope.querySelectorAll('[data-bar]')).map(function (el) {
      return {
        el: el,
        prog: el.querySelector('[data-bar-progress]'),
        start: parseFloat(el.getAttribute('data-start') || '0'),
        end: parseFloat(el.getAttribute('data-end') || '100'),
      };
    });

    // Cache hình học track + mỗi nhãn (theo phần-trăm-track) để tính "lộ dần" KHÔNG đọc layout
    // mỗi frame. Nhãn nằm trong vùng sticky pin → vị trí x đứng yên khi cuộn → cache đủ.
    var trackLeft = 0, trackW = 1, labelFrac = [];
    function measure() {
      if (!track) return;
      var tr = track.getBoundingClientRect();
      trackLeft = tr.left; trackW = tr.width || 1;
      labelFrac = labels.map(function (l) {
        var r = l.getBoundingClientRect();
        return { s: (r.left - trackLeft) / trackW, w: (r.width || 1) / trackW };
      });
    }

    function inRange(el, p) {
      var s = parseFloat(el.getAttribute('data-start') || '0');
      var e = parseFloat(el.getAttribute('data-end') || '100');
      return p >= s - 0.5 && p <= e + 0.5;
    }

    function apply(p) {
      p = clamp(p, 0, 100);
      var pf = p / 100;
      // Track-fill: scaleX bám scroll 1:1 (transform → GPU, không repaint layout).
      if (fill) fill.style.transform = 'scaleX(' + pf + ')';
      // Nhãn: màu chữ LỘ DẦN — mỗi nhãn đặt --tabim-rv = % bề rộng nhãn mà mép tiến độ đã quét
      // qua (gradient clip-text ở CSS) → phần trái accent, phải xám, ranh giới trượt mượt.
      labels.forEach(function (l, i) {
        var f = labelFrac[i]; if (!f) return;
        var lr = f.w > 0 ? clamp((pf - f.s) / f.w, 0, 1) * 100 : (pf >= f.s ? 100 : 0);
        l.style.setProperty('--tabim-rv', lr.toFixed(1) + '%');
      });
      // Node: "cục tròn" CHỈ ở giai đoạn (không trôi giữa thanh — như Coterie). active = giai
      // đoạn ĐÃ TỚI gần nhất (last-reached, mép fill đã vượt) → phình to; trước đó = accent nhỏ;
      // chưa tới = xám nhỏ. Bulge nhảy sang node KẾ khi mép fill chạm node đó (không đi trước).
      var activeIdx = Math.max(0, Math.min(n - 1, Math.floor(pf * (n - 1) + 1e-9)));
      nodes.forEach(function (nd, i) {
        nd.classList.toggle('is-active', i === activeIdx);
        nd.classList.toggle('is-past', i < activeIdx);
      });

      // Thanh phủ sản phẩm: tô TIẾN DẦN theo p (tri-state done/active/future như Coterie).
      // active = thanh chỉ số CAO NHẤT đang fill dở (frontier); nếu không có → thanh đã xong
      // cuối; nếu p≈0 chưa thanh nào chạy → thanh đầu. Chỉ NHÃN thanh active sáng accent.
      var active = -1, lastDone = -1;
      barData.forEach(function (b, i) {
        var span = b.end - b.start;
        var t = span > 0 ? clamp((p - b.start) / span, 0, 1) : (p >= b.start ? 1 : 0);
        if (b.prog) {
          b.prog.style.transform = 'scaleX(' + t + ')';
          // Mép dẫn mềm chỉ khi đang fill dở (0<t<1); xong = tint đặc. toggle no-op nếu không đổi.
          b.prog.classList.toggle('is-filling', t > 0 && t < 1);
        }
        if (t > 0 && t < 1) active = i;
        if (t >= 1) lastDone = i;
      });
      if (active === -1) active = lastDone >= 0 ? lastDone : 0;
      barData.forEach(function (b, i) { b.el.classList.toggle('is-active', i === active); });
      cards.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
      images.forEach(function (el) { el.classList.toggle('is-active', inRange(el, p)); });
    }

    // Map page-scroll position of the tall outer wrapper → 0..1 progress.
    function progress() {
      var r = scroll.getBoundingClientRect();
      var denom = r.height - window.innerHeight;
      return denom > 0 ? clamp((0 - r.top) / denom, 0, 1) : 0;
    }

    // Smooth như Coterie: trong lúc cuộn chạy rAF-loop MỖI frame (đọc vị trí scroll mới nhất →
    // apply), thay vì chỉ nghe 'scroll' (event hay bị gộp dưới refresh rate khi fling). Loop tự
    // tắt sau ~12 frame không có scroll mới (~100–200ms) → không đốt pin lúc đứng yên.
    var looping = false, scrolled = false, idle = 0;
    function frame() {
      apply(progress() * 100);
      if (scrolled) { scrolled = false; idle = 0; } else { idle++; }
      if (idle < 12) { requestAnimationFrame(frame); } else { looping = false; }
    }
    function onScroll() {
      scrolled = true;
      if (!looping) { looping = true; idle = 0; requestAnimationFrame(frame); }
    }
    function onResize() { measure(); apply(progress() * 100); }

    // Click a label → smooth-scroll to that stage's scroll offset (keeps the click
    // affordance, but the source of truth stays the scroll position).
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    labels.forEach(function (l, i) {
      l.addEventListener('click', function () {
        var r = scroll.getBoundingClientRect();
        var denom = r.height - window.innerHeight;
        if (denom <= 0) { apply((i / (n - 1)) * 100); return; }
        var target = window.scrollY + r.top + (i / (n - 1)) * denom + 1;
        window.scrollTo({ top: target, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    measure();
    apply(progress() * 100);
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('[data-stage-slider]');
    Array.prototype.forEach.call(els, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
